import { Action, createReducer, on } from '@ngrx/store';
import * as shippingRequestsActions from 'src/app/compliance/store/actions/shipping-requests.actions';
import { ShippingRequestsState } from 'src/app/compliance/store/state/shipping-requests.state';

const initialState: ShippingRequestsState = {
    assignees: [],
    isLoading: false,
    error: null,
    reloadGrid: false, // temporary prop to gap store-grid functionality
    filter: {
        filter: {},
        sort: {
            field: 'id',
            dir: 'desc'
        },
        skip: 0,
        pageSize: 50
    },
    shippingRequests: null
};

const reducer = createReducer(
    initialState,
    on(shippingRequestsActions.reassignBulkTickets, (state, action) => ({
        ...state,
        isLoading: true,
        reloadGrid: false
    })),
    on(shippingRequestsActions.reassignBulkTicketsSuccess, (state, action) => ({
        ...state,
        isLoading: false,
        reloadGrid: true
    })),
    on(shippingRequestsActions.reassignBulkTicketsFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false
    })),
    on(shippingRequestsActions.getListOfAssignees, (state, action) => ({
        ...state,
        isLoading: true,
        assignees: []
    })),
    on(shippingRequestsActions.getListOfAssigneesSuccess, (state, action) => ({
        ...state,
        assignees: action.assignees,
        isLoading: false
    })),
    on(
        shippingRequestsActions.getListOfAssigneesFailure,
        shippingRequestsActions.getListOfShippingRequestsFailure,
        (state, action) => ({
            ...state,
            error: action.error,
            isLoading: false
        })
    ),
    on(shippingRequestsActions.setShippingRequestsFilter, (state, action) => ({
        ...state,
        filter: action.filter,
        shippingRequests: null,
        isLoading: true
    })),
    on(shippingRequestsActions.getListOfShippingRequestsSuccess, (state, action) => ({
        ...state,
        shippingRequests: action.shippingRequests,
        isLoading: false,
        error: null
    }))
);

export function shippingRequestsReducer(state: ShippingRequestsState | undefined, action: Action) {
    return reducer(state, action);
}
